import { createAuthPersistence } from './authPersistence';
import { createDefaultBrowserStorageDriver } from './browserStorageDriver';
import { createLocalRedactedPersistenceReporter } from './persistenceReporter';

let productionInstance = null;
let productionTestOverride = null;

/**
 * Lazy production facade — resolves browser localStorage on first call only.
 */
export function getProductionAuthPersistence() {
  if (productionTestOverride) {
    return productionTestOverride;
  }
  if (!productionInstance) {
    productionInstance = createAuthPersistence({
      driver: createDefaultBrowserStorageDriver(),
      reporter: createLocalRedactedPersistenceReporter(),
    });
  }
  return productionInstance;
}

/** @internal P-1D test injection — not for production callers */
export function __setProductionAuthPersistenceForTests(facade) {
  productionTestOverride = facade;
}

/** @internal test hook */
export function __resetProductionAuthPersistence() {
  productionInstance = null;
  productionTestOverride = null;
}
